/** The shared user and role dialogs' copy, `modals.*` (moved out of en.ts to keep it shrinking). */
export const enModals = {
	addAvatar: {
		description: "<underline>Click to upload</underline> or drag and drop",
		fileSize: "Max file size is 3 MB",
		title: "Upload File",
	},
	deleteRole: {
		title: "Delete role",
	},
	deleteUser: {
		title: "Delete user",
	},
	editUser: {
		rolePlaceholder: "Select Roles",
		title: "Edit user",
		supportLabel: "Support staff (receives out-of-credits alerts)",
	},
};
